import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/plugins/element';
import '@/utils/permission';
import Loading from '@/plugins/loading';
import Warning from '@/plugins/warning';
import setRem from "@/utils/rem";
import minxinObj from '@/utils/commonMixin';
import ElementUI from 'element-ui';

setRem()
Vue.mixin(minxinObj);
Vue.use(Loading);
Vue.use(Warning);
Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
